import { authMiddleware } from "@/middleware";
import { createFileRoute } from "@tanstack/react-router";

import { DashboardLayout } from "@/components";
import HomePage from "@/pages/dashboard/Dashboard";

export const Route = createFileRoute("/_market/dashboard")({
	component: () => (
		<DashboardLayout>
			<HomePage />
		</DashboardLayout>
	),
	loader: authMiddleware,
});
